"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hyperapp_1 = require("../../../hyperapp");
exports.UiKitEFieldLabel = (_, children) => hyperapp_1.h("label", { className: "e-field__label" }, children);
//# sourceMappingURL=uikit-e-field-label.js.map